import { getApiBaseUrl } from '@/app/runtime';
import normalizeBaseDomain from './clients/normalizeBaseDomain';

const resource = '/analytics/events';

function analyticsUrl() {
  return `${normalizeBaseDomain(getApiBaseUrl())}${resource}`;
}

export function trackBatch(events, { beacon = false } = {}) {
  const payload = { events: Array.isArray(events) ? events : [] };
  if (payload.events.length === 0) {
    return Promise.resolve({ data: { accepted: 0 } });
  }

  if (
    beacon &&
    typeof navigator !== 'undefined' &&
    typeof navigator.sendBeacon === 'function' &&
    typeof Blob !== 'undefined'
  ) {
    const sent = navigator.sendBeacon(
      analyticsUrl(),
      new Blob([JSON.stringify(payload)], { type: 'application/json' })
    );
    if (sent) {
      return Promise.resolve({ data: { accepted: payload.events.length, beacon: true } });
    }
  }

  // The website has no portal session, toasts or stores; a plain fetch keeps the
  // portal client (and its i18n/store graph) out of the website bundle. The portal
  // keeps Client so its Bearer token lets the backend attribute the events.
  if (process.env.VUE_APP_BUILD_TARGET === 'website') {
    return fetch(analyticsUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).then(async (response) => ({ data: await response.json().catch(() => null) }));
  }
  return import('./clients/Client').then(({ default: Client }) => Client.post(resource, payload));
}

export default {
  trackBatch,
};
